(function () {
  function updateLinkVariant(link, variantId) {
    if (!link || !variantId) return;

    try {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.href;
    } catch (e) {
      const baseUrl = (link.getAttribute('href') || '').split('?')[0];
      if (baseUrl) link.href = baseUrl + '?variant=' + variantId;
    }
  }

  function initEditorialCard(card) {
    if (!card || card.dataset.editorialReady === 'true') return;

    const carousel = card.querySelector('.media-carousel');
    const imageLink = card.querySelector('.media-carousel-container');
    const titleLink = card.querySelector('.full-unstyled-link');

    if (!carousel || !imageLink || !titleLink) return;

    let mediaVariantMap = {};
    try {
      mediaVariantMap = JSON.parse(card.dataset.mediaVariantMap || '{}');
    } catch (e) {
      mediaVariantMap = {};
    }

    const swatches = Array.from(card.querySelectorAll('.swatch'));
    const slides = Array.from(carousel.children);
    const prevButton = card.querySelector('.media-arrow--prev');
    const nextButton = card.querySelector('.media-arrow--next');

    let isDragging = false;
    let isScrolling = false;
    let startX = 0;
    let scrollLeft = 0;
    let scrollTimeout = null;

    const slidesInfo = [];
    let currentVariantIdForBlock = null;
    slides.forEach((slide) => {
      const mediaId = slide.dataset.mediaId;
      if (mediaVariantMap[mediaId]) currentVariantIdForBlock = mediaVariantMap[mediaId];
      slidesInfo.push({
        mediaId,
        variantId: currentVariantIdForBlock,
      });
    });

    function updateLinks(variantId) {
      updateLinkVariant(imageLink, variantId);
      updateLinkVariant(titleLink, variantId);
    }

    function updateActiveSwatch(activeVariantId) {
      swatches.forEach((swatch) => {
        swatch.classList.toggle('swatch--selected', swatch.dataset.variantId === activeVariantId);
      });
    }

    function getActiveVariantId() {
      const activeIndex = Math.round(carousel.scrollLeft / Math.max(carousel.offsetWidth, 1));
      return slidesInfo[activeIndex] ? slidesInfo[activeIndex].variantId : null;
    }

    function onDragStart(event) {
      isDragging = true;
      isScrolling = false;
      startX = (event.pageX || event.touches[0].pageX) - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      carousel.style.scrollSnapType = 'none';
      carousel.style.cursor = 'grabbing';
    }

    function onDragMove(event) {
      if (!isDragging) return;
      isScrolling = true;
      event.preventDefault();
      const x = (event.pageX || event.touches[0].pageX) - carousel.offsetLeft;
      carousel.scrollLeft = scrollLeft - (x - startX);
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      carousel.style.scrollSnapType = 'x mandatory';
      carousel.style.cursor = 'grab';
      setTimeout(() => {
        isScrolling = false;
      }, 50);
    }

    function handleScroll() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const activeVariantId = getActiveVariantId();
        if (!activeVariantId) return;
        updateLinks(activeVariantId);
        updateActiveSwatch(activeVariantId);
      }, 150);
    }

    function handleSwatchClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const swatch = event.currentTarget;
      const variantId = swatch.dataset.variantId;
      const mediaId = swatch.dataset.variantMediaId;
      const targetSlide = carousel.querySelector('.media-item[data-media-id="' + mediaId + '"]');

      if (!targetSlide) return;

      carousel.style.transition = 'opacity 0.2s ease-in-out';
      carousel.style.opacity = '0';

      setTimeout(() => {
        carousel.scrollTo({ left: targetSlide.offsetLeft, behavior: 'auto' });
        carousel.style.opacity = '1';

        setTimeout(() => {
          carousel.style.transition = '';
        }, 200);

        updateLinks(variantId);
        updateActiveSwatch(variantId);
      }, 100);
    }

    carousel.addEventListener('mousedown', onDragStart);
    carousel.addEventListener('mousemove', onDragMove);
    carousel.addEventListener('mouseup', onDragEnd);
    carousel.addEventListener('mouseleave', onDragEnd);
    carousel.addEventListener('touchstart', onDragStart, { passive: true });
    carousel.addEventListener('touchmove', onDragMove, { passive: false });
    carousel.addEventListener('touchend', onDragEnd);
    carousel.addEventListener('scroll', handleScroll, { passive: true });

    imageLink.addEventListener('click', (event) => {
      if (isScrolling) event.preventDefault();
    });

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' });
      });
    }

    swatches.forEach((swatch) => swatch.addEventListener('click', handleSwatchClick));

    if (swatches.length > 0) {
      const firstSwatch = swatches[0];
      firstSwatch.classList.add('swatch--selected');
      updateLinks(firstSwatch.dataset.variantId);
    }

    card.dataset.editorialReady = 'true';
  }

  function hydrateVideo(video) {
    if (!video || video.dataset.videoReady === 'true') return;

    const source = video.querySelector('source[data-src]');
    if (!source) return;

    source.src = source.dataset.src;
    source.removeAttribute('data-src');
    video.load();
    video.dataset.videoReady = 'true';
  }

  function boot() {
    const cards = Array.from(document.querySelectorAll('[data-stoerer-editorial-card]'));
    const videos = Array.from(document.querySelectorAll('[data-editorial-video]'));

    if ('IntersectionObserver' in window) {
      const cardObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            initEditorialCard(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '300px 0px' }
      );

      cards.forEach((card) => cardObserver.observe(card));

      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              hydrateVideo(video);
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { rootMargin: '300px 0px', threshold: 0.15 }
      );

      videos.forEach((video) => videoObserver.observe(video));
      return;
    }

    cards.forEach(initEditorialCard);
    videos.forEach((video) => {
      hydrateVideo(video);
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
